import { FunctionComponent } from 'react';

import { useStatusGame, useGames } from '../hooks';
import SliderItem from './SliderItem';
import _ from 'lodash';

const Slider: FunctionComponent = () => {
  const [getGames] = useGames();

  const [gameStatus] = useStatusGame();

  return (
    <section
      style={{
        display: ![2, 3].includes(gameStatus) ? 'none' : 'block',
      }}
    >
      {_.map(_.chunk(getGames, 5), (getGames, index) => (
        <div
          key={index}
          className={`case-play-slider isGame-${gameStatus} ${
            _.size(getGames) > 1 && 'case-play-slider-vertical'
          }`}
        >
          <div className="shadow-left"></div>
          <div className="shadow-right"></div>
          <div className="case-play-slider-arrow" />
          <div className="case-open-slider">
            {getGames.map(getGame => (
              <SliderItem getGame={getGame} key={getGame?.getGame?.id} />
            ))}
          </div>
        </div>
      ))}
    </section>
  );
};

export default Slider;
